import { render } from "./ResultDetail.vue?vue&type=template&id=08012210&scoped=true"
import script from "./ResultDetail.vue?vue&type=script&lang=js"
export * from "./ResultDetail.vue?vue&type=script&lang=js"

import "./ResultDetail.vue?vue&type=style&index=0&id=08012210&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08012210"]])

export default __exports__